import { createPortal } from "react-dom";
import React, { useContext, useEffect, useState } from "react";
import Header from "./header.jsx";
import Search from "./search.jsx";
import ItemsSelected from "./itemsSelected.jsx";
import background from "assets/images/header.png";
import barasas from "assets/images/barasas.png";
import dastebandi from "assets/images/dastebandi.png";
import asan from "assets/images/asan.png";
import sib1 from "assets/images/sib1.png";
import sib2 from "assets/images/sib2.png";
import logo1 from "assets/images/logo6.png";
import bg1 from "assets/images/bg4.png";

import Formatter from "hoc/Formatter";

import ListLines from "pages/ListLines";
import StoreList from "./StoreList.jsx";
import "./fastOrdering.scss";
import { connection } from "utils/apiConnection.ts";
import Loader from "utils/Loader";

export default function FastOrderingModal() {
  const [isLoading, setIsLoading] = useState(false);

  const [fastOrderingInfo, setFastOrderingInfo] = useState([
    {
      headerInfo: [
        { headerBackground: background, headerTitle: "انواع سفارش ها" },
      ],
      search: [
        { imgSearch: asan, titleSearch: "سفارش آسان", id: 0 },
        { imgSearch: barasas, titleSearch: "براساس فروشگاه", id: 1 },
        { imgSearch: dastebandi, titleSearch: " دسته بندی", id: 2 },
      ],
      searchItems: [
        {
          id: 0,
          img: sib2,
          store: "میوه تره بار آویژه",
          Score: "4",
          product: "سیب سبز",
          type: "نوع A",
          unit: "یک کیلو",
          price: "25000",
          count: 1,
        },
        {
          id: 1,
          img: sib1,
          store: "میوه تره بار آویژه",
          Score: "4",
          product: "سیب سبز",
          type: "نوع A",
          unit: "یک کیلو",
          price: "25000",
          count: 1,
        },
      ],
      itemSelected: [
        // {
        //   img: hemati,
        //   store: "میوه تره بار همتی",
        //   Score: "4",
        //   title: "سیب سبز",
        //   weight_from: 2,
        //   count: 3,
        //   price: 25000,
        // },
        // {
        //   img: avizhe,
        //   store: "میوه تره بار آویژه",
        //   Score: "4",
        //   title: "سیب قرمز",
        //   weight_from: 3,
        //   count: 4,
        //   price: 35000,
        // },
      ],
    },
  ]);

  // useEffect(() => {
  //   fetchProductItems()
  // }, []);
  const [storeList, setStoreList] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    connection("superadminapi/getsuppliers").then((data) => {
      setStoreList(data);
      console.log("data-supp:", data);
    });
    setIsLoading(false);
  }, []);
  const [selectedItem, setSelectedItem] = useState(0);
  const returnJSXBasedOnSelectedItem = () => {
    switch (selectedItem) {
      case 0:
        return (
          <>
            {isLoading && <Loader />}
            <Search
              fastOrderingInfo={fastOrderingInfo}
              setFastOrderingInfo={setFastOrderingInfo}
              // searchItem={searchItem}
              // setSearchItem={setSearchItem}
              // fetchProductItems={fetchProductItems}
            ></Search>
            <ItemsSelected
              fastOrderingInfo={fastOrderingInfo}
              setFastOrderingInfo={setFastOrderingInfo}
            ></ItemsSelected>
          </>
        );
      case 1:
        return (
          <>
            {isLoading && <Loader />}

            <StoreList
              storeList={storeList}
              setStoreList={setStoreList}
              logo1={logo1}
              bg1={bg1}
            />
          </>
        );
      case 2:
        return (
          <>
            {/* <div
              style={{
                width: "260px",
                height: "60px",
                color: "white",
                borderRadius: "25px 15px 0px 0px",
                padding: "18px",
                fontWeight: "500",
                backgroundColor: "red",
                textAlign: "center",
                fontSize: "18px",
                marginTop: "150px",
              }}
            >
              {" "}
              تایتل
            </div> */}
            <div
              className="container"
              style={{
                // backgroundColor: "red",
                height: "2px",
                marginTop: "170px",
                // marginTop: "-80px",
              }}
            >
              {isLoading && <Loader />}

              <Formatter
                color={"#5a3eff"}
                header={"دسته بندی محصولات"}
              ></Formatter>

              <ListLines />
            </div>
          </>
        );
    }
  };
  useEffect(() => {
    console.log("fastOrderingInfo", fastOrderingInfo);
  }, [fastOrderingInfo]);
  const modalVar = (
    <div
      style={{ backgroundColor: "#f1eae5" }}
      className="modal fade"
      id="fastOrdering"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      {isLoading && <Loader />}

      <div
        className="modal-dialog modal-fullscreen"
        style={{ backgroundColor: "#f1eae5" }}
      >
        <div className="modal-content" style={{ backgroundColor: "#f1eae5" }}>
          <button
            style={{ marginTop: "20px", marginRight: "20px", padding: "10px" }}
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />{" "}
          <div className="modal-body">
            <Header
              fastOrderingInfo={fastOrderingInfo}
              setFastOrderingInfo={setFastOrderingInfo}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            ></Header>

            {returnJSXBasedOnSelectedItem()}
          </div>
        </div>
      </div>
    </div>
  );
  return createPortal(modalVar, document.querySelector("#modals"));
}
